import Vue from "vue";
import Router from "vue-router";
import { i18n } from '@/plugins/i18n'
import { Trans } from '@/plugins/Translation';

Vue.use(Router);

function load (component) {
  return () => import(`@/views/${component}.vue`)
}

export default new Router({
  mode: "history",
  base: '/',
  routes: [
    {
    path: '/be:lang',
    component: {
      template: '<router-view></router-view>'
    },
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: load('Home')
      },
      {
        path: 'vitaliteit',
        name: 'vitaliteit',
        component: {
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            component: load('Home')
          },
          {
            path: i18n.t('routes.sport.apps', 'nl'),
            name: i18n.t('routes.sport.apps', 'nl'),
            component: load('articles/SportApps')
          },
          {
            path: i18n.t('routes.sport.kiwi', 'nl'),
            name: i18n.t('routes.sport.kiwi', 'nl'),
            component: load('articles/SportKiwi')
          },
          {
            path: i18n.t('routes.mind.lachen', 'nl'),
            name: i18n.t('routes.mind.lachen', 'nl'),
            component: load('articles/MindLachen')
          },
          {
            path: i18n.t('routes.mind.humeur', 'nl'),
            name: i18n.t('routes.mind.humeur', 'nl'),
            component: load('articles/MindHumeur')
          },
          {
            path: i18n.t('routes.food.fruit', 'nl'),
            name: i18n.t('routes.food.fruit', 'nl'),
            component: load('articles/FoodFruit')
          },
          {
            path: i18n.t('routes.food.ontbijt', 'nl'),
            name: i18n.t('routes.food.ontbijt', 'nl'),
            component: load('articles/FoodOntbijt')
          }
        ]
      },
      {
        path: 'vitalite',
        name: 'vitalite',
        component: {
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            component: load('Home')
          },
          {
            path: i18n.t('routes.sport.apps', 'fr'),
            name: i18n.t('routes.sport.apps', 'fr'),
            component: load('articles/SportApps')
          },
          {
            path: i18n.t('routes.sport.kiwi', 'fr'),
            name: i18n.t('routes.sport.kiwi', 'fr'),
            component: load('articles/SportKiwi')
          },
          {
            path: i18n.t('routes.mind.lachen', 'fr'),
            name: i18n.t('routes.mind.lachen', 'fr'),
            component: load('articles/MindLachen')
          },
          {
            path: i18n.t('routes.mind.humeur', 'fr'),
            name: i18n.t('routes.mind.humeur', 'fr'),
            component: load('articles/MindHumeur')
          },
          {
            path: i18n.t('routes.food.fruit', 'fr'),
            name: i18n.t('routes.food.fruit', 'fr'),
            component: load('articles/FoodFruit')
          },
          {
            path: i18n.t('routes.food.ontbijt', 'fr'),
            name: i18n.t('routes.food.ontbijt', 'fr'),
            component: load('articles/FoodOntbijt')
          }
        ]
      },
    ]
  },
  {
    path: '*',
    redirect () {
      return 'be'+Trans.getUserSupportedLang()
    }
  }
  ]
});

// export default new Router({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes: [
//     {
//     path: '/:lang',
//     component: {
//       template: '<router-view></router-view>'
//     },
//     beforeEnter: Trans.routeMiddleware,
//     children: [
//       {
//         path: 'vitaliteit',
//         name: 'vitaliteit',
//         alias: '/:lang',
//         component: load('Home')
//       },
//       {
//         path: 'vitalite',
//         name: 'vitalite',
//         alias: '/:lang',
//         component: load('Home')
//       },
//       {
//         path: i18n.t('routes.sport.apps', 'nl'),
//         name: i18n.t('routes.sport.apps', 'nl'),
//         component: load('articles/SportApps')
//       },
//       {
//         path: i18n.t('routes.sport.apps', 'fr'),
//         name: i18n.t('routes.sport.apps', 'fr'),
//         component: load('articles/SportApps')
//       },
//       {
//         path: i18n.t('routes.sport.kiwi', 'nl'),
//         name: i18n.t('routes.sport.kiwi', 'nl'),
//         component: load('articles/SportKiwi')
//       },
//       {
//         path: i18n.t('routes.sport.kiwi', 'fr'),
//         name: i18n.t('routes.sport.kiwi', 'fr'),
//         component: load('articles/SportKiwi')
//       },
//       {
//         path: i18n.t('routes.mind.lachen', 'nl'),
//         name: i18n.t('routes.mind.lachen', 'nl'),
//         component: load('articles/MindLachen')
//       },
//       {
//         path: i18n.t('routes.mind.lachen', 'fr'),
//         name: i18n.t('routes.mind.lachen', 'fr'),
//         component: load('articles/MindLachen')
//       },
//       {
//         path: i18n.t('routes.mind.humeur', 'nl'),
//         name: i18n.t('routes.mind.humeur', 'nl'),
//         component: load('articles/MindHumeur')
//       },
//       {
//         path: i18n.t('routes.mind.humeur', 'fr'),
//         name: i18n.t('routes.mind.humeur', 'fr'),
//         component: load('articles/MindHumeur')
//       },
//       {
//         path: i18n.t('routes.food.fruit', 'nl'),
//         name: i18n.t('routes.food.fruit', 'nl'),
//         component: load('articles/FoodFruit')
//       },
//       {
//         path: i18n.t('routes.food.fruit', 'fr'),
//         name: i18n.t('routes.food.fruit', 'fr'),
//         component: load('articles/FoodFruit')
//       },
//       {
//         path: i18n.t('routes.food.ontbijt', 'nl'),
//         name: i18n.t('routes.food.ontbijt', 'nl'),
//         component: load('articles/FoodOntbijt')
//       },
//       {
//         path: i18n.t('routes.food.ontbijt', 'fr'),
//         name: i18n.t('routes.food.ontbijt', 'fr'),
//         component: load('articles/FoodOntbijt')
//       }
//     ]
//   },
//   {
//     path: '*',
//     redirect () {
//       return Trans.getUserSupportedLang()
//     }
//   }
//   ]
// });
